<div [formGroup]="group">
  <mat-chip-listbox multiple>
    @for (value of values; track value) {
      <mat-chip-option
        #chip="matChip"
        (click)="chip.toggleSelected()"
        (selectionChange)="toggleChip(value)"
        [selected]="getControl(value).value"
        >
        {{ display(value) }}
        @if (getControl(value).value) {
          <img alt="Cancel" src="/assets/default/cancel.svg">
        }
      </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
